// ----------------------------------------------------------------------
// <copyright file="Izenda.DashStyleDropdown.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  DashStyleDropdown component
 */
!(function () {
  var React = require('react');
  var m = require('mobx-react');

  var UIConstants = require('logic/data/Izenda.UIConstants');
  var FloatAffixed = require('./Izenda.FloatAffixed');
  var classnames = require('classnames');

  var DashStyleDropdown = React.createClass({

    propsType: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func
    },

    getInitialState: function() {
      return {
        isOpen: false
      }
    },

    getDefaultProps: function () {
      return {
        value: UIConstants.defaultDashStyles
      };
    },

    onChange: function (value) {
      this.props.onChange && this.props.onChange(value);
      this.hideDashStyles();
    },

    showDashStyles: function() {
      this.setState({ isOpen: !this.state.isOpen });
    },

    hideDashStyles: function() {
      this.setState({ isOpen: false });
    },

    render: function () {
      var listStyles = UIConstants.dashStyles.map(function (item) {
        return (
          <div className='izenda-Dropdown-option'
              value={item}
              onClick={this.onChange.bind(this, item)}
              key={item}>
            <div className={item}></div>
          </div>
        );
      }.bind(this));

      var selectItem = this.props.value ? this.props.value + ' review-icon' : 'dotted review-icon';
      var classes = classnames('izenda-DashStyleDropDown u_controlHeight', {
        'disabled-elm': this.props.disabled
      });

      return (
        <div className={classes}>
          <div ref="dashStyle" className='line-style' onMouseDown={this.showDashStyles}>
            <div className={selectItem}></div>
            <i className='icon-triangle-down'/>
          </div>

          {this.state.isOpen &&
            <FloatAffixed
              anchor={this.refs.dashStyle}
              onClickOutside={this.hideDashStyles}
              onParentScroll={this.hideDashStyles}
              className="izenda-Dropdown izenda-DashStyleDropDown"
            >
              <div className='izenda-Dropdown-menu'>
                {listStyles}
              </div>
            </FloatAffixed>
          }
        </div>
      );
    }
  });

  module.exports = m.observer(DashStyleDropdown);
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DashStyleDropdown.jsx